import type { PromptTemplateListingCategory } from '../api';

/** Ключ localStorage: текст шаблона для поля «Системный промпт» на /ai-settings */
export const AI_SETTINGS_SYSTEM_PROMPT_PREFILL_KEY = 'globus_ai_settings_system_prompt_prefill';

const NORMALIZED_SYSTEM_PROMPT_TITLE = 'системный промпт';

export function hasSystemPromptCategory(
  categories: PromptTemplateListingCategory[] | undefined
): boolean {
  if (!categories?.length) return false;
  return categories.some((c) => c.title.trim().toLowerCase() === NORMALIZED_SYSTEM_PROMPT_TITLE);
}
